import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const linesApiRoutes = {
    list: apiDataManagerBaseURL + "lines/",
    listDraft: apiDataManagerBaseURL + "linesdraft/",
    listWithActiveDraft: apiDataManagerBaseURL + "linesdraft/withactive/",
    load: apiDataManagerBaseURL + "lines/",
    countActiveNetwork: apiDataManagerBaseURL + "lines/count/",
    countDraft: apiDataManagerBaseURL + "linesdraft/count/",
    create: apiDataManagerBaseURL + "lines/",
    createDraft: apiDataManagerBaseURL + "linesdraft/",
    update: apiDataManagerBaseURL + "lines/",
    updateDraft: apiDataManagerBaseURL + "linesdraft/",
    delete: apiDataManagerBaseURL + "lines/",
    deleteDraft: apiDataManagerBaseURL + "linesdraft/",
    takeover: apiDataManagerBaseURL + "lines/"
};

export class LineAPI {
    static list(networkEdition, provider = '') {
        const listUrl = `${linesApiRoutes.list}${networkEdition}`;

        return API.authenticatedRequest({
            url: provider === '' ? listUrl : `${listUrl}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftNetworkEdition, provider = '') {
        const url = `${linesApiRoutes.listDraft}${draftNetworkEdition}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listWithActiveDraft(networkEdition, draftNetworkEdition, provider = '') {
        const url = `${linesApiRoutes.listWithActiveDraft}${networkEdition}/${draftNetworkEdition}`;
        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(networkEdition, id) {
        return API.authenticatedRequest({
            url: `${linesApiRoutes.load}${networkEdition}/${id}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countActive(networkEdition, providerId = '') {
        const countUrl = `${linesApiRoutes.countActiveNetwork}${networkEdition}/`;

        return API.authenticatedRequest({
            url: providerId === '' ? countUrl : `${countUrl}?providerId=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countDraft(draftNetworkEdition, providerId) {
        const countUrl = `${linesApiRoutes.countDraft}${draftNetworkEdition}/${providerId}`;

        return API.authenticatedRequest({
            url: countUrl,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(networkEdition, line) {
        return API.authenticatedRequest({
            url: `${linesApiRoutes.create}${networkEdition}`,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(line)
        });
    }

    static createDraft(draftNetworkEdition, line) {
        return API.authenticatedRequest({
            url: `${linesApiRoutes.createDraft}${draftNetworkEdition}`,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(line)
        });
    }

    static update(networkEdition, id, line) {
        return API.authenticatedRequest({
            url: `${linesApiRoutes.update}${networkEdition}/${id}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(line)
        });
    }

    static updateDraft(draftNetworkEdition, id, line) {
        const url = `${linesApiRoutes.updateDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(line)
        });
    }

    static delete(networkEdition, id) {
        return API.authenticatedRequest({
            url: `${linesApiRoutes.delete}${networkEdition}/${id}`,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftNetworkEdition, id) {
        const url = `${linesApiRoutes.deleteDraft}${draftNetworkEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
    
    static takeover(networkEdition, id, line, provider) {
        return API.authenticatedRequest({
            url: `${linesApiRoutes.takeover}${networkEdition}/${id}/takeover?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(line)
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/LineAPI.js